<template>
  <div class="app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 2" :key="item">
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col cols="4">
          <v-text-field dense :value="form.description.toUpperCase()" :error-messages="descriptionErrors" :counter="30"
            label="Nome" outlined @input="
              $v.form.description.$touch()
            form.description = $event.toUpperCase().trim()
              " @blur="$v.form.description.$touch()" />
        </v-col>
        <v-col cols="4">
          <v-text-field dense v-model="form.ipServidor" :error-messages="ipServidorErrors" label="Endereço de Registro"
            outlined @input="
              $v.form.ipServidor.$touch()
            form.ipServidor = $event.trim()
              " @blur="$v.form.ipServidor.$touch()" />
        </v-col>
        <v-col cols="4">
          <v-text-field dense v-model="form.domain" :error-messages="fromDomainErrors" label="Domínio de Origem"
            outlined @input="
              $v.form.domain.$touch()
            form.domain = $event.trim()
              " @blur="$v.form.domain.$touch()" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-text-field dense v-model="form.porta" :error-messages="portaErrors" label="Porta" type="number" outlined
            @input="$v.form.porta.$touch()" @blur="$v.form.porta.$touch()" />
        </v-col>
        <v-col cols="4">
          <v-select dense v-model="form.dtmf" :error-messages="dtmfErrors" :items="dtmf" outlined label="DTMF"
            @input="$v.form.dtmf.$touch()" @blur="$v.form.dtmf.$touch()" />
        </v-col>
        <v-col cols="4">
          <v-select dense v-model="form.quality" :error-messages="qualityErrors" :items="quality" outlined
            label="Quality" @input="$v.form.quality.$touch()" @blur="$v.form.quality.$touch()" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-text-field dense v-model="form.contactUser" label="Contato" outlined :error-messages="contactUserErrors"
            @input="$v.form.quality.$touch()" @blur="$v.form.quality.$touch()" />
        </v-col>
        <v-col cols="4">
          <v-text-field dense v-model="form.media_address" label="Media address" outlined />
        </v-col>
        <v-col cols="4">
          <v-text-field dense v-model="form.outbound_proxy" label="Outbound proxy" outlined />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="4">
          <div class="d-flex">
            <v-checkbox dense class="mr-4" v-model="form.interno" label="Interno" />
            <v-checkbox dense class="mr-4" v-model="form.force_rport" label="Force rport" />
            <v-checkbox dense v-model="form.rewrite_contact" label="Rewrite contact" />
          </div>
        </v-col>
        <v-col cols="4">
        </v-col>
        <v-col cols="4">
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <DraggAndDrop dragname="Codecs" :valoresDisponiveisComboBox="codecs.codecsDisponiveis"
            @dragUpdate="updateCodecs($event)" :opcoes-selecionadas="codecs.codecsSelecionadas" />
        </v-col>
        <v-col v-show="!form.interno">
          <DraggAndDrop dragname="Rotas" :valoresDisponiveisComboBox="rotasGerais.rotasGeralDisponiveis"
            @dragUpdate="updateRotasGeral($event)" :opcoesSelecionadas="rotasGerais.rotasGeralSelecionadas" />
        </v-col>
      </v-row>
      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule, formatarRota } from '@/utils/vuexUtils'
import { ordenar } from '@/utils/ordenarArrayByText'
import DraggAndDrop from '../_components/DraggAndDrop'
import troncosStore from '../_store'
import { validateData, validateComputed } from '../_validates/validatePjsiptrunk'
import TroncosHttpService from '../_services/TroncosHttpService'

export default {
  name: 'AbaRamalPjsip',
  props: {
    edicao: String,
    _id: String,
  },
  components: { Snackbar, DraggAndDrop, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      description: '',
      tipo: 'PJSIPTRUNK',
      ipServidor: '',
      domain: '',
      porta: '5060',
      codecs: [],
      dtmf: 'rfc4733',
      quality: 'yes',
      interno: false,
      rota: [],
      contactUser: '',
      media_address: '',
      outbound_proxy: '',
      force_rport: true,
      rewrite_contact: true,
    },
    rotasGerais: {
      rotasGeralDisponiveis: [],
      rotasGeralSelecionadas: [],
    },
    codecs: {
      codecsDisponiveis: ['alaw', 'ulaw', 'gsm', 'g729', 'h263', 'h264'],
      codecsSelecionadas: [],
    },
    dtmf: ['rfc4733', 'inband', 'info'],
    quality: ['yes', 'no'],
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('abaTroncoPJSIPTrunkModulePABXStore', ['getRotasDisponiveis', 'getTroncoSelecionado']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'abaTroncoPJSIPTrunkModulePABXStore', troncosStore)

    await this.listarRotas()

    this.rotasGerais.rotasGeralDisponiveis = [...this.getRotasDisponiveis]

    if (this.edicao === 'true') {
      this.form = this.getTroncoSelecionado

      let arrayrotasSelecionadas = Object.values(this.getTroncoSelecionado.rota)

      arrayrotasSelecionadas.forEach(rotasSelecionadas => {
        const indexRotaGeral = this.rotasGerais.rotasGeralDisponiveis.findIndex(
          rotaGeral => rotaGeral._id === rotasSelecionadas
        )

        if (indexRotaGeral !== -1) {
          this.rotasGerais.rotasGeralSelecionadas.push(this.rotasGerais.rotasGeralDisponiveis[indexRotaGeral])
        }
      })

      if (typeof this.form.codecs !== 'undefined') {
        this.codecs.codecsSelecionadas = [...this.form.codecs]
      }
    } else {
      this.codecs.codecsSelecionadas.push('alaw', 'ulaw', 'gsm')
      this.rotasGerais.rotasGeralSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)
    }

    ordenar(this.rotasGerais.rotasGeralDisponiveis)
    ordenar(this.codecs.codecsDisponiveis)
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('abaTroncoPJSIPTrunkModulePABXStore', ['listarRotas']),
    updateCodecs(event) {
      this.form.codecs = event
    },
    updateRotasGeral(event) {
      this.form.rota = formatarRota(event)
    },
    async salvar() {
      this.pararLoader.parar = false

      if (!this.form.codecs.length) {
        this.text = 'Nenhum codec Selecionado'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      } else if (!this.form.rota['1']) {
        this.text = 'Nenhuma rota selecionada.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this.edicao === 'true') {
          delete this.form.numero
          await TroncosHttpService.putTronco(this.form)
        } else {
          await TroncosHttpService.postTronco(this.form)
        }

        this.$router.push({ name: 'Troncos' })
      } catch (error) {
        this.text = error.response.data
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Troncos' })
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
